import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Route } from 'react-router';

import RoutePath from '@custom-types/RoutePath';
import { LoginType } from '@hooks/useLogin';
import { generateRoute } from '@services/navigation-service';

import ForgotPassword from './ForgotPassword';
import ForgotPasswordSuccess from './ForgotPasswordSuccess';
import Home from './Home';
import Login from './Login';

export default () => (
  <IonRouterOutlet>
    <Route exact path={generateRoute(RoutePath.Login)}>
      <Home />
    </Route>
    <Route
      path={generateRoute(RoutePath.LoginWithPassword)}
      render={props => <Login type={LoginType.WithPassword} {...props} />}
    />
    <Route
      path={generateRoute(RoutePath.LoginWithCode)}
      render={props => <Login type={LoginType.WithAccessCode} {...props} />}
    />
    <Route
      path={generateRoute(RoutePath.ForgotPassword)}
      render={props => <ForgotPassword type={LoginType.WithPassword} {...props} />}
    />
    <Route
      path={generateRoute(RoutePath.ForgotAccessCode)}
      render={props => <ForgotPassword type={LoginType.WithAccessCode} {...props} />}
    />
    <Route
      path={generateRoute(RoutePath.ForgotPasswordSuccess)}
      component={ForgotPasswordSuccess}
    />
  </IonRouterOutlet>
);
